import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppBarView from "@/views/app_bar/AppBarView.vue";
import { useUserInfoStore } from "@/stores/userInfoStore";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { signIn, signOut } from "@/firebase/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBarPresenter',
  setup(__props) {

const userInfoStore = useUserInfoStore();
const { loggedIn } = storeToRefs(userInfoStore);

const router = useRouter();

function navigateToTitle() {
  router.push({ name: "home" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarView, {
    "logged-in": _unref(loggedIn),
    onTitlePressed: navigateToTitle,
    onSignInPressed: _unref(signIn),
    onSignOutPressed: _unref(signOut)
  }, null, 8, ["logged-in", "onSignInPressed", "onSignOutPressed"]))
}
}

})